import mod from "-!./Gallery.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Gallery.js?vue&type=script&lang=js&external"